import { render, staticRenderFns } from "./xlcs.vue?vue&type=template&id=0bb74143"
import script from "./xlcs.vue?vue&type=script&lang=js"
export * from "./xlcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports